var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.layout)?_c('v-app',[_c(_vm.layout,{tag:"component"},[_c('router-view')],1),_c('notifications',{staticClass:"notify",attrs:{"position":"top center","group":"notify"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }